import { render, staticRenderFns } from "./DistributeMenuButton.vue?vue&type=template&id=e1ccbb2c&"
import script from "./DistributeMenuButton.vue?vue&type=script&lang=js&"
export * from "./DistributeMenuButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports